import {datadogLogs} from '@datadog/browser-logs'
import {configs, getProfile} from 'src/common/helpers/config'
import {shouldSendBrowserLog} from './browserFilter'
import {getLogConfig} from './config'
import {consoleSink} from './consoleSink'
import {isBotUserAgent} from './isBot'
import type {LogSink} from './types'

const SESSION_SAMPLE_RATE = 100

let initialized = false

const isBot = (): boolean => typeof navigator !== 'undefined' && isBotUserAgent(navigator.userAgent)

const sendsToDatadog = (): boolean => getProfile() !== 'dev' && !isBot()

export const initBrowserLogging = (): void => {
  if (initialized || !sendsToDatadog()) {
    return
  }

  initialized = true

  const {clientToken, env} = getBrowserCredentials()
  const {service, version} = getLogConfig()

  datadogLogs.init({
    clientToken,
    env,
    service,
    version,
    site: 'datadoghq.eu',
    trackingConsent: 'not-granted',
    forwardErrorsToLogs: true,
    forwardConsoleLogs: [],
    forwardReports: [],
    sessionSampleRate: SESSION_SAMPLE_RATE,
    useSecureSessionCookie: true,
    beforeSend: shouldSendBrowserLog,
  })

  datadogLogs.logger.setLevel('error')
}

const getBrowserCredentials = (): {clientToken: string; env: string} => {
  const {ENV_DATADOG_CLIENT_TOKEN, ENV} = configs[getProfile()]

  return {clientToken: ENV_DATADOG_CLIENT_TOKEN, env: ENV}
}

export const setBrowserLoggingConsent = (granted: boolean): void => {
  if (sendsToDatadog()) {
    datadogLogs.setTrackingConsent(granted ? 'granted' : 'not-granted')
  }
}

export const browserSink: LogSink = (level, message, attributes) => {
  if (sendsToDatadog()) {
    datadogLogs.logger[level](message, attributes)
  } else {
    consoleSink(level, message, attributes)
  }
}
